module.exports = __webpack_public_path__ + "media/images/samples/infographics/article-img@2x-7058d3b9e6109e7d336276b6375d520f.jpg";